import SendReplyStep from './SendReplyStep.vue'
import { sendReplyDescriptor } from './descriptor'
import { createSendReplyController } from './send-reply-controller'

const sendReplyStepImplementation = Object.freeze({
    descriptor: sendReplyDescriptor,
    component: SendReplyStep,
    createController: createSendReplyController,
})

export {
    SendReplyStep,
    createSendReplyController,
    sendReplyDescriptor,
    sendReplyStepImplementation,
}
